// extracted by mini-css-extract-plugin
export default {"root":"UtvP6LQ2","dots":"PdzBnsGR","starIcon":"w919CqtI","tonInUsdDescription":"VMKBAQXy"};